import { KeyActionEvaluation } from '../../../services/assessment/assessment.mapping'

type CategoryScore = { category: string; average: number }

const SPECIAL_TENANT_ORG_IDS = ['trygroup', 'test.xpotential.co.jp', 'demo.try']

export const SPECIAL_TENANT_CATEGORIES_ORDER = [
  '教育コンサルタントスキル',
  '営業スキル',
]

/** スペシャルテナントかどうかを判定する */
export function isSpecialTenant(orgId: string | undefined): boolean {
  return SPECIAL_TENANT_ORG_IDS.includes(orgId ?? '')
}

/** カテゴリ別スコアを計算する */
export function computeCategoryScores(
  evaluations: KeyActionEvaluation[],
  orgId: string | undefined,
): CategoryScore[] {
  const categoryMap = new Map<string, { total: number; count: number }>()

  evaluations.forEach((evaluation) => {
    const categories = evaluation.keyAction.categories
    if (!categories) return

    categories.forEach((category) => {
      if (!category) return
      if (!categoryMap.has(category)) {
        categoryMap.set(category, { total: 0, count: 0 })
      }
      const data = categoryMap.get(category)!
      data.total += evaluation.score
      data.count++
    })
  })

  const results = Array.from(categoryMap.entries()).map(
    ([category, { total, count }]) => ({
      category,
      average: total / count,
    }),
  )

  if (isSpecialTenant(orgId)) {
    return sortSpecialTenantCategories(results)
  }
  return results.sort((a, b) => b.average - a.average)
}

/** KAがハイライト（良かった点）かどうかを判定する */
export function isHighlightEvaluation(
  evaluation: KeyActionEvaluation,
  threshold: number,
  specialTenantWithoutCategories: boolean,
): boolean {
  if (specialTenantWithoutCategories) {
    return evaluation.score >= 3
  }
  return evaluation.score >= threshold
}

/** KAがロウライト（改善したい点）かどうかを判定する */
export function isLowLightEvaluation(
  evaluation: KeyActionEvaluation,
  threshold: number,
  specialTenantWithoutCategories: boolean,
): boolean {
  if (specialTenantWithoutCategories) {
    return evaluation.score < 3
  }
  return evaluation.score < threshold
}

/** スペシャルテナントかつKAカテゴリがない場合を判定する */
export function isSpecialTenantWithoutCategories(
  orgId: string | undefined,
  categoryScoresLength: number,
): boolean {
  return isSpecialTenant(orgId) && categoryScoresLength === 0
}

function sortSpecialTenantCategories(
  categories: CategoryScore[],
): CategoryScore[] {
  return categories.sort((a, b) => {
    const aIndex = SPECIAL_TENANT_CATEGORIES_ORDER.indexOf(a.category)
    const bIndex = SPECIAL_TENANT_CATEGORIES_ORDER.indexOf(b.category)
    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex
    if (aIndex !== -1) return -1
    if (bIndex !== -1) return 1
    return b.average - a.average
  })
}
